import { render, staticRenderFns } from "./LoginP.vue?vue&type=template&id=b555557a&scoped=true&"
import script from "./LoginP.vue?vue&type=script&lang=js&"
export * from "./LoginP.vue?vue&type=script&lang=js&"
import style0 from "./LoginP.vue?vue&type=style&index=0&id=b555557a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b555557a",
  null
  
)

export default component.exports